import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Reusable server selector dropdown.
 *
 * Props:
 *   servers:  array of { id, name, color, is_active }
 *   value:    selected server id
 *   onChange: (newId) => void
 *   loading:  boolean
 */
const ServerSelector = ({ servers = [], value, onChange, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="h-10 w-full md:w-64 rounded-xl skeleton" />
    );
  }

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold whitespace-nowrap">
        {t('superadmin.businessRules.server', 'Server')}
      </label>
      <div className="relative">
        <select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="pl-9 pr-8 py-2 rounded-xl bg-card border border-border text-foreground text-base font-medium outline-none focus:border-accent focus:ring-2 focus:ring-accent/20 appearance-none min-w-[12rem]"
        >
          {servers.length === 0 && <option value="">—</option>}
          {servers.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
              {!s.is_active ? ' (inactive)' : ''}
            </option>
          ))}
        </select>
        {/* Color swatch */}
        {(() => {
          const current = servers.find((s) => s.id === value);
          const color = current?.color || '#94a3b8';
          return (
            <span
              className="absolute left-3 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full border border-border"
              style={{ backgroundColor: color }}
            />
          );
        })()}
        {/* Caret */}
        <svg
          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M3 5l3 3 3-3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default ServerSelector;
